import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "duration", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useState } from 'react';
import { useTheme } from '../Flowbite/ThemeContext';
import { ToastContext } from './ToastContext';
import { ToastToggle } from './ToastToggle';
var durationClasses = {
  75: 'duration-75',
  100: 'duration-100',
  150: 'duration-150',
  200: 'duration-200',
  300: 'duration-300',
  500: 'duration-500',
  700: 'duration-700',
  1000: 'duration-1000'
};
var ToastComponent = function ToastComponent(_ref) {
  var children = _ref.children,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 300 : _ref$duration,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClosed = _useState2[0],
    setIsClosed = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRemoved = _useState4[0],
    setIsRemoved = _useState4[1];
  var theme = useTheme().theme.toast;
  return _jsx(ToastContext.Provider, {
    value: {
      duration: duration,
      isClosed: isClosed,
      isRemoved: isRemoved,
      setIsClosed: setIsClosed,
      setIsRemoved: setIsRemoved
    },
    children: _jsx("div", _objectSpread(_objectSpread({
      "data-testid": "flowbite-toast",
      className: classNames(theme.base, durationClasses[duration], _defineProperty({}, theme.closed, isClosed), _defineProperty({}, theme.removed, isRemoved), className)
    }, props), {}, {
      children: children
    }))
  });
};
ToastComponent.displayName = 'Toast';
ToastToggle.displayName = 'Toast.Toggle';
export var Toast = Object.assign(ToastComponent, {
  Toggle: ToastToggle
});